import { useQueryClient } from '@tanstack/react-query'

import { useLocalStorage } from '@/hooks'
import type { TUsuarioLogado } from '@/http'
import { setLocalidade } from '@/infra/i18n'
import type { TGrupoDeUnidadesDeNegocioDisponivel } from '@/types/unidade-negocio'

export const useTrocaRegional = (user: TUsuarioLogado) => {
  const queryClient = useQueryClient()
  const [_, setUser] = useLocalStorage<TUsuarioLogado>('user', user)
  const regionalAtual: TGrupoDeUnidadesDeNegocioDisponivel = {
    id: user.grupoDeUnidadesDeNegocioId,
    nome: user.grupoDeUnidadesDeNegocioNome,
    principal: true,
    localidade: user.localidade ?? 'pt-BR',
    permiteAcessoASimulacaoRapida: false,
  }

  const handleRegionalChange = async (regional?: TGrupoDeUnidadesDeNegocioDisponivel) => {
    if (!regional) return
    queryClient.removeQueries()

    await setLocalidade(regional.localidade)
    setUser((prev) => ({
      ...prev,
      grupoDeUnidadesDeNegocioNome: regional.nome,
      grupoDeUnidadesDeNegocioId: regional.id,
      localidade: regional.localidade,
    }))
  }

  return { regionalAtual, handleRegionalChange }
}
